/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useRef } from "react";

import Button from "components/Button";
import Label from "components/Label";
import Autocomplete from "react-google-autocomplete";
import { AiOutlineClear as ClearIcon } from "react-icons/ai";
import { FaMapMarkerAlt as MapIcon } from "react-icons/fa";

import styles from "./styles.module.scss";

type Props = {
  onChange(place: any): void;
  value: any;
  placeholder?: string;
  id?: string;
  disabled?: boolean;
};

const GoogleMapsAutocomplete: FC<Props> = ({
  onChange,
  value,
  placeholder,
  id,
  disabled = false
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className={styles.container}>
      <div className={styles.autocompleteWrapper}>
        <Autocomplete
          ref={inputRef}
          id={id}
          placeholder={placeholder}
          options={{ types: "address", fields: "formatted_address" }}
          className={styles.autocomplete}
          apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}
          onPlaceSelected={(place) => {
            onChange(place);
          }}
        />
        <Button
          disabled={disabled}
          variant="text"
          onClick={() => {
            onChange(undefined);
            if (inputRef.current) inputRef.current.value = "";
          }}
          Icon={<ClearIcon className={styles.icon} />}
        />
      </div>
      {value?.formatted_address && (
        <div className={styles.detail}>
          <MapIcon className={styles.mapIcon} />
          <Label color="white">{value?.formatted_address}</Label>
        </div>
      )}
    </div>
  );
};

GoogleMapsAutocomplete.defaultProps = {
  placeholder: undefined,
  id: undefined,
  disabled: false
};

export default GoogleMapsAutocomplete;
